const translations = {
  APPROVAL_APPROVE_REQUEST: {
    description: "Approve Request",
    primaryValue: "Approve Request",
    stringKey: "APPROVAL_APPROVE_REQUEST",
  },
  APPROVAL_YOUR_EMPLOYEE: {
    description: "Your Employee",
    primaryValue: "Your employee,",
    stringKey: "APPROVAL_YOUR_EMPLOYEE",
  },
  APPROVAL_YOUR_EMPLOYEE_NOTIFIED: {
    description: "will be notified of your decision",
    primaryValue: "will be notified of your decision",
    stringKey: "APPROVAL_YOUR_EMPLOYEE_NOTIFIED",
  },
  APPROVAL_CANCEL: {
    description: "Cancel",
    primaryValue: "Cancel",
    stringKey: "APPROVAL_CANCEL",
  },
  APPROVAL_APPROVE: {
    description: "Approve",
    primaryValue: "Approve",
    stringKey: "APPROVAL_APPROVE",
  },
  APPROVAL_DECLINE_REQUEST: {
    description: "Decline Request",
    primaryValue: "Decline Request",
    stringKey: "APPROVAL_DECLINE_REQUEST",
  },
  APPROVAL_VISITORS: {
    description: "Visitors Heading",
    primaryValue: "Visitors",
    stringKey: "APPROVAL_VISITORS",
  },
  APPROVAL_VISITOR: {
    description: "Visitor Heading",
    primaryValue: "Visitor",
    stringKey: "APPROVAL_VISITOR",
  },
  APPROVAL_REQUESTED_BY: {
    description: "Pass Requested By",
    primaryValue: "Requested By",
    stringKey: "APPROVAL_REQUESTED_BY",
  },
  APPROVAL_VISITOR_HEADING: {
    description: "Name of the Visitor",
    primaryValue: "Visitor Name",
    stringKey: "APPROVAL_VISITOR_HEADING",
  },
  APPROVAL_RELATIONSHIP: {
    description: "Relationship with the Sponsor",
    primaryValue: "Relationship",
    stringKey: "APPROVAL_RELATIONSHIP",
  },
  APPROVAL_STORE: {
    description: "Requested Store",
    primaryValue: "Store",
    stringKey: "APPROVAL_STORE",
  },
  APPROVAL_CURRENT: {
    description: "Approval Current",
    primaryValue: "Current",
    stringKey: "APPROVAL_CURRENT",
  },
  APPROVAL_EDITED: {
    description: "Approval Edited",
    primaryValue: "Edited",
    stringKey: "APPROVAL_EDITED",
  },
  APPROVAL_STATUS_APPROVED: {
    description: "Pass Status Approved",
    primaryValue: "Approved",
    stringKey: "APPROVAL_STATUS_APPROVED",
  },
  APPROVAL_REQUEST_APPROVED: {
    description: "Pass Request Approved",
    primaryValue: "Request Approved",
    stringKey: "APPROVAL_REQUEST_APPROVED",
  },
  APPROVAL_ERROR_APPROVING: {
    description: "Error while approving passes",
    primaryValue: "Error approving passes",
    stringKey: "APPROVAL_ERROR_APPROVING",
  },
  APPROVAL_REQUEST_DECLINED: {
    description: "Pass Request Declined",
    primaryValue: "Request Declined",
    stringKey: "APPROVAL_REQUEST_DECLINED",
  },
  APPROVAL_ERROR_DECLINING: {
    description: "Error while declining passes",
    primaryValue: "Error declining passes",
    stringKey: "APPROVAL_ERROR_DECLINING",
  },
  APPROVAL_DECLINE: {
    description: "Decline Request",
    primaryValue: "Decline",
    stringKey: "APPROVAL_DECLINE",
  },
  RELATIONSHIP_BROTHER: {
    description: "Relationship of type Brother",
    primaryValue: "Brother",
    stringKey: "RELATIONSHIP_BROTHER",
  },
  RELATIONSHIP_BROTHER_IN_LAW: {
    description: "Relationship of type Brother-in-law",
    primaryValue: "Brother-in-law",
    stringKey: "RELATIONSHIP_BROTHER_IN_LAW",
  },
  RELATIONSHIP_CHILD: {
    description: "Relationship of type Child",
    primaryValue: "Child",
    stringKey: "RELATIONSHIP_CHILD",
  },
  RELATIONSHIP_DAUGHTER: {
    description: "Relationship of type Daughter",
    primaryValue: "Daughter",
    stringKey: "RELATIONSHIP_DAUGHTER",
  },
  RELATIONSHIP_DAUGHTER_IN_LAW: {
    description: "Relationship of type Daughter-in-law",
    primaryValue: "Daughter-in-law",
    stringKey: "RELATIONSHIP_DAUGHTER_IN_LAW",
  },
  RELATIONSHIP_FATHER: {
    description: "Relationship of type Father",
    primaryValue: "Father",
    stringKey: "RELATIONSHIP_FATHER",
  },
  RELATIONSHIP_FATHER_IN_LAW: {
    description: "Relationship of type Father-in-law",
    primaryValue: "Father-in-law",
    stringKey: "RELATIONSHIP_FATHER_IN_LAW",
  },
  RELATIONSHIP_GRANDCHILD: {
    description: "Relationship of type Grandchild",
    primaryValue: "Grandchild",
    stringKey: "RELATIONSHIP_GRANDCHILD",
  },
  RELATIONSHIP_GRANDFATHER: {
    description: "Relationship of type Grandfather",
    primaryValue: "Grandfather",
    stringKey: "RELATIONSHIP_GRANDFATHER",
  },
  RELATIONSHIP_GRANDFATHER_IN_LAW: {
    description: "Relationship of type Grandfather-in-law",
    primaryValue: "Grandfather-in-law",
    stringKey: "RELATIONSHIP_GRANDFATHER_IN_LAW",
  },
  RELATIONSHIP_GRANDMOTHER: {
    description: "Relationship of type Grandmother",
    primaryValue: "Grandmother",
    stringKey: "RELATIONSHIP_GRANDMOTHER",
  },
  RELATIONSHIP_GRANDMOTHER_IN_LAW: {
    description: "Relationship of type Grandmother-in-law",
    primaryValue: "Grandmother-in-law",
    stringKey: "RELATIONSHIP_GRANDMOTHER_IN_LAW",
  },
  RELATIONSHIP_GRAND_DAUGHTER: {
    description: "Relationship of type Grand Daughter",
    primaryValue: "Grand Daughter",
    stringKey: "RELATIONSHIP_GRAND_DAUGHTER",
  },
  RELATIONSHIP_GRAND_SON: {
    description: "Relationship of type Grand Son",
    primaryValue: "Grand Son",
    stringKey: "RELATIONSHIP_GRAND_SON",
  },
  RELATIONSHIP_MOTHER: {
    description: "Relationship of type Mother",
    primaryValue: "Mother",
    stringKey: "RELATIONSHIP_MOTHER",
  },
  RELATIONSHIP_MOTHER_IN_LAW: {
    description: "Relationship of type Mother-in-law",
    primaryValue: "Mother-in-law",
    stringKey: "RELATIONSHIP_MOTHER_IN_LAW",
  },
  RELATIONSHIP_SISTER: {
    description: "Relationship of type Sister",
    primaryValue: "Sister",
    stringKey: "RELATIONSHIP_SISTER",
  },
  RELATIONSHIP_SISTER_IN_LAW: {
    description: "Relationship of type Sister-in-law",
    primaryValue: "Sister-in-law",
    stringKey: "RELATIONSHIP_SISTER_IN_LAW",
  },
  RELATIONSHIP_SON: {
    description: "Relationship of type Son",
    primaryValue: "Son",
    stringKey: "RELATIONSHIP_SON",
  },
  RELATIONSHIP_SON_IN_LAW: {
    description: "Relationship of type Son-in-law",
    primaryValue: "Son-in-law",
    stringKey: "RELATIONSHIP_SON_IN_LAW",
  },
  RELATIONSHIP_SPOUSE_PARTNER: {
    description: "Relationship of type Spouse/Partner",
    primaryValue: "Spouse/Partner",
    stringKey: "RELATIONSHIP_SPOUSE_PARTNER",
  },
  RELATIONSHIP_STEP_BROTHER: {
    description: "Relationship of type Step Brotherr",
    primaryValue: "Step Brotherr",
    stringKey: "RELATIONSHIP_STEP_BROTHER",
  },
  RELATIONSHIP_STEP_DAUGHTER: {
    description: "Relationship of type Step Daughter",
    primaryValue: "Step Daughter",
    stringKey: "RELATIONSHIP_STEP_DAUGHTER",
  },
  RELATIONSHIP_STEP_FATHER: {
    description: "Relationship of type Step Father",
    primaryValue: "Step Father",
    stringKey: "RELATIONSHIP_STEP_FATHER",
  },
  RELATIONSHIP_STEP_FATHER_IN_LAW: {
    description: "Relationship of type Step Father-in-law",
    primaryValue: "Step Father-in-law",
    stringKey: "RELATIONSHIP_STEP_FATHER_IN_LAW",
  },
  RELATIONSHIP_STEP_MOTHER: {
    description: "Relationship of type Step Mother",
    primaryValue: "Step Mother",
    stringKey: "RELATIONSHIP_STEP_MOTHER",
  },
  RELATIONSHIP_STEP_MOTHER_IN_LAW: {
    description: "Relationship of type Step Mother-in-law",
    primaryValue: "Step Mother-in-law",
    stringKey: "RELATIONSHIP_STEP_MOTHER_IN_LAW",
  },
  RELATIONSHIP_STEP_SISTER: {
    description: "Relationship of type Step Sister",
    primaryValue: "Step Sister",
    stringKey: "RELATIONSHIP_STEP_SISTER",
  },
  RELATIONSHIP_STEP_SON: {
    description: "Relationship of type Step Son",
    primaryValue: "Step Son",
    stringKey: "RELATIONSHIP_STEP_SON",
  },
};

export default translations;
